import type { Lens, SessionCapabilities, Tier } from "../session/types";

export interface RailItem {
  family: string;
  label: string;
  to: string;
  scoped: boolean;
  requiredLens?: Lens;
  tierLabels?: Partial<Record<Tier, string>>;
  tierTo?: Partial<Record<Tier, string>>;
}

export const RAIL_ITEMS: RailItem[] = [
  { family: "home", label: "Home", to: "/", scoped: false },
  { family: "actions", label: "Actions", to: "/t/$tenant/s/$scope/actions", scoped: true, tierLabels: { easy_m: "Alerts" }, tierTo: { easy_m: "/t/$tenant/s/$scope/alerts" } },
  { family: "plants", label: "Plants", to: "/t/$tenant/s/$scope/plants", scoped: true, requiredLens: "energy" },
  { family: "performance", label: "Performance", to: "/t/$tenant/s/$scope/kpi", scoped: true, requiredLens: "energy" },
  { family: "ledgers", label: "Ledgers", to: "/t/$tenant/s/$scope/ledgers", scoped: true },
  { family: "work", label: "Work", to: "/t/$tenant/s/$scope/work", scoped: true },
  { family: "docs", label: "Docs", to: "/t/$tenant/s/$scope/docs", scoped: true, requiredLens: "documents" },
  { family: "reports", label: "Reports", to: "/t/$tenant/s/$scope/reports", scoped: true },
  { family: "ask", label: "Ask", to: "/t/$tenant/s/$scope/ask", scoped: true },
  { family: "admin", label: "Admin", to: "/t/$tenant/s/$scope/admin", scoped: true },
];

export interface VisibleRailItem extends RailItem {
  locked: boolean;
  locked_tier?: string;
  stub: boolean;
}

export function visibleRailItems(caps: SessionCapabilities): VisibleRailItem[] {
  const lenses = new Set(caps.lenses);
  const families = new Map(caps.rail_families.map((f) => [f.name, f]));
  const tier = caps.tier;

  return RAIL_ITEMS.flatMap((item) => {
    const fam = families.get(item.family);
    if (!fam || !fam.visible) return [];
    if (item.requiredLens && !lenses.has(item.requiredLens)) return [];
    const label = item.tierLabels?.[tier] ?? item.label;
    const to = item.tierTo?.[tier] ?? item.to;
    return [{ ...item, label, to, locked: fam.locked, locked_tier: fam.locked_tier, stub: fam.stub ?? false }];
  });
}
